import { createContext, useContext } from 'react';

function createContextUtilities(defaultValue) {
  var context = /*#__PURE__*/createContext(defaultValue);

  var useContextWrapper = function useContextWrapper() {
    var value = useContext(context);

    if (value === undefined) {
      throw new Error('useContext must be called inside a provider or be initialized with a default value');
    }

    return value;
  };

  return {
    Provider: context.Provider,
    // asserting so `undefined` can't be passed to provider
    useContext: useContextWrapper
  };
}

export { createContextUtilities as default };
